import {Routes} from '@angular/router';
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {CustomerDashboardComponent} from "./components/customer-dashboard/customer-dashboard.component";
import {PageNotFoundComponent} from "./components/page-not-found/page-not-found.component";
import {PageForbiddenComponent} from './components/page-forbidden/page-forbidden.component';
import {canActivateAuthRole} from "./guard/auth.guard";
import {administrationRoutes} from "./components/administration/administration.routes";
import {AppComponent} from './app.component';
/**
 * Contains all the app's first level routes. Second level routes and beyond are defined in the respective component's
 * routes definition file, e.g. administration.routes.ts
 */
export const routes: Routes = [{
  path: 'administration',
  children: administrationRoutes,
  canActivate: [canActivateAuthRole],
  data: {roles: ['admin']}
}, {
  path: 'scapi',
  component: DashboardComponent,
  canActivate: [canActivateAuthRole],
  data: {roles: ['scapi']}
}, {
  path: 'customerDashboard',
  component: CustomerDashboardComponent,
  canActivate: [canActivateAuthRole],
  data: {roles: ['customer']}
}, {
  path: '',
  component: AppComponent,
  canActivate: [canActivateAuthRole],
  data: {roles: []}
}, {
  path: 'page-not-found',
  component: PageNotFoundComponent
}, {
  path: 'page-forbidden',
  component: PageForbiddenComponent
}, {
  path: '**',
  redirectTo: '/page-not-found'
}];
